<template>
  <v-container>
    <v-row v-if="stage == 0" class="text-center" justify="space-around">
      <v-col cols="12">
        <h1>Welcome to Fap Cards!</h1>
      </v-col>
      <v-col cols="12">
        <h4>The rules are simple! First, you'll select which decks you would like to play with. You can choose from pre-made decks or select each expansion individually.</h4>
      </v-col>
      <v-col cols="12">
        <h4>After selecting your deck, select how long you'd like to play. This does not affect the duration of cards, and rounds can still go long.</h4>
      </v-col>
      <v-col cols="12">
        <h4>The only thing round length determines is how soon cum cards are added to the deck.</h4>
      </v-col>
      <v-col cols="12">
        <h4>After you draw a card, simply follow the task and draw another card!</h4>
      </v-col>
      <v-col cols="12">
        <h4>If a drawn card interferes with a previously drawn card, the new card takes precedence.</h4>
      </v-col>
      <v-col cols="12">
        <v-btn @click="stage++">Let's Fap!</v-btn>
      </v-col>
    </v-row>
    <v-row v-if="stage == 1" class="text-center" justify="space-around">
      <v-col cols="12">
        <h1>Select Your Deck</h1>
      </v-col>
      <v-col cols="12">
        <v-btn @click="stage++" v-if="!this.$vuetify.breakpoint.smAndDown">Continue</v-btn>
      </v-col>
      <v-col cols="12">
        <v-row v-if="this.$vuetify.breakpoint.smAndDown" class="text-center" justify="space-around">
          <v-col v-for='deck in decks' cols="12">
              <v-card
              max-width="344"
              class="mx-auto"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="headline">{{deck.name}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
          
              <v-img
                :src="deck.img"
                height="194"
              ></v-img>
          
              <v-card-text>
                {{deck.desc}}
              </v-card-text>
          
              <v-card-actions>
                <v-btn
                  text
                  color="deep-purple accent-4"
                  @click="sets = deck.sets"
                >
                  Select
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-btn
          dark
          bottom
          right
          fixed
          fab
          @click="stage++"
        >
        Next
        </v-btn>
        </v-row>
        <v-row v-else class="text-center" justify="space-around">
            <v-col v-for='deck in decks' cols="4">
                <v-card
                max-width="344"
                class="mx-auto"
              >
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="headline">{{deck.name}}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
            
                <v-img
                  :src="deck.img"
                  height="194"
                ></v-img>
            
                <v-card-text>
                  {{deck.desc}}
                </v-card-text>
            
                <v-card-actions>
                  <v-btn
                    text
                    color="deep-purple accent-4"
                    @click="sets = deck.sets"
                  >
                    Select
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
      </v-col>
      <v-col cols="12">
        <v-row v-if="stage == 1" class="text-center" justify="space-around">
          <v-switch v-model="sets" label="Base Set Oral" value="Oral" color='blue lighten-3'></v-switch>
          <v-switch v-model="sets" label="Extreme Oral" value="Extreme Oral" color='blue darken-4'></v-switch>
          <v-switch v-model="sets" label="Base Set Anal" value="Anal" color='orange lighten-3'></v-switch>
          <v-switch v-model="sets" label="Anim-Anal" value="Anim-Anal" color='orange darken-4'></v-switch>
          <v-switch v-model="sets" label="Anim-Oral" value="Anim-Oral" color='blue darken-1'></v-switch>
          <v-switch v-model="sets" label="Base Set Sissy" value="Sissy" color='pink'></v-switch>
          <v-switch v-model="sets" label="Base Set BDSM" value="BDSM" color='black'></v-switch>
          <v-switch v-model="sets" label="Three's Company" value="ThreesCompany" color='deep-purple lighten-2'></v-switch>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="stage == 2" class="text-center" justify="space-around">
      <v-col cols="12">
        <h1>Select Your Game Duration</h1>
      </v-col>
      <v-col cols="12">
        <v-btn @click="begin">Continue</v-btn>
      </v-col>
      <v-col cols="12">
        <v-row class="text-center" justify="space-around">
          <v-switch v-model="gameLength" label="Quick" value="4"></v-switch>
          <v-switch v-model="gameLength" label="Normal" value="10"></v-switch>
          <v-switch v-model="gameLength" label="Long" value="20"></v-switch>
        </v-row>
      </v-col>
      </v-row>
    <v-row class="text-center" justify="space-around" v-if="stage == 3">
      <v-btn @click="draw" :disabled="came">Draw A Card</v-btn>
    </v-row>
    <v-row class="text-center" justify="space-around" v-if="stage == 3">
        <fapCards
        v-for="card in drawnCards.slice(Math.max(drawnCards.length - cutSpot, 0))"
        v-bind:key="card.name"
        v-bind:name="card.name"
        v-bind:image="card.image"
        v-bind:color="card.color"
        v-bind:desc="card.desc"
        v-bind:deck="card.deck"
      ></fapCards>
    </v-row>
  </v-container>
</template>

<script>
  import fapCards from '../../components/fapCardTemplate';

  export default {
    name: 'fapCardsGame',
    components: {
      fapCards,
    },
    data: () => ({
      stage: 0,
      drawNumer: 0,
      came: false,
      decks: [
        {
          name: 'Standard',
          img: 'https://i.imgur.com/OycEmlE.jpg',
          sets: ['Oral', 'Anal'],
          desc: 'Standard deck consisting of anal and oral cards',
          color: 'blue lighten-3'
        },
        {
          name: 'Sissy BDSM',
          img: 'https://i.imgur.com/cBf68eZ.jpg',
          sets: ['Oral', 'Anal', 'Sissy', 'BDSM'],
          desc: 'Includes oral, anal, BDSM, and feminization',
          color: 'pink'
        },
        {
          name: 'Anim-All',
          img: 'https://i.imgur.com/X0qv0WO.gif',
          sets: ['Anim-Oral', 'Anim-Anal'],
          desc: 'Includes all animated sets',
          color: 'orange'
        }
      ],
      sets: ['Oral', 'Anal'],
      gameLength: 4,
      oralCards: [
        {
          name: 'Misty Law',
          image: 'https://i.imgur.com/bihDmS6.jpg',
          color: 'blue lighten-3',
          deck: 'Base Set Oral',
          desc: 'Lick the balls/base of your dildo for 2 minutes.'
        },
        {
          name: 'Katie Kush',
          image: 'https://i.imgur.com/7GoAwZb.jpg',
          color: 'blue lighten-3',
          deck: 'Base Set Oral',
          desc: 'Make out with the tip of your dildo for 1 minute.'
        },
        {
          name: 'Lara Page',
          image: 'https://i.imgur.com/dot1eps.jpg',
          color: 'blue lighten-3',
          deck: 'Base Set Oral',
          desc: 'Deepthroat your dildo 3 times'
        },
        {
          name: 'Heather Starlet',
          image: 'https://i.imgur.com/IkGxVBh.jpg',
          color: 'blue lighten-3',
          deck: 'Base Set Oral',
          desc: 'Throat fuck yourself for 30 seconds'
        },
        {
          name: 'Yvette Balcano',
          image: 'https://i.imgur.com/kMXZQch.jpg',
          color: 'blue lighten-3',
          deck: 'Base Set Oral',
          desc: 'Rub yourself with your dildo in your mouth for 3 minutes'
        },
        {
          name: 'Hannah Harper',
          image: 'https://i.imgur.com/CpETfj6.jpg',
          color: 'blue lighten-3',
          deck: 'Base Set Oral',
          desc: 'Lick the tip of your dildo for 1 minute'
        },
        {
          name: 'Bobbi Starr',
          image: 'https://i.imgur.com/ogwFhtw.jpg',
          color: 'blue lighten-3',
          deck: 'Base Set Oral',
          desc: 'Suck your dildo with tight suction for 1 minute'
        },
        {
          name: 'Hannah Hays',
          image: 'https://i.imgur.com/TMa9FcD.jpg',
          color: 'blue lighten-3',
          deck: 'Base Set Oral',
          desc: 'Kiss yourself in the mirror 10 times'
        },
        {
          name: 'Roxy Deville',
          image: 'https://i.imgur.com/v2JH4Dq.jpg',
          color: 'blue lighten-3',
          deck: 'Base Set Oral',
          desc: 'Suck your dildo on the mirror for 1 minute. Try to kiss yourself.'
        },
        {
          name: 'Yasmin Scott',
          image: 'https://i.imgur.com/X5LgJaJ.jpg',
          color: 'blue lighten-3',
          deck: 'Base Set Oral',
          desc: 'Bob your head on your dildo for 2 minutes'
        },
        {
          name: 'Sarah Kay',
          image: 'https://i.imgur.com/7LCUt94.jpg',
          color: 'blue lighten-3',
          deck: 'Base Set Oral',
          desc: 'Suck your dildo while moaning for 1 minute'
        },
        {
          name: 'Angelic Anya',
          image: 'https://i.imgur.com/09dyfSb.jpg',
          color: 'blue lighten-3',
          deck: 'Base Set Oral',
          desc: 'Suck your dildo while stroking it for 4 minutes'
        },
        {
          name: 'Kylie Nymphette',
          image: 'https://i.imgur.com/tL1ilSl.jpg',
          color: 'blue lighten-3',
          deck: 'Base Set Oral',
          desc: 'Try to hold a deep throat for 15 seconds'
        },
      ],
      extremeOral: [
        {
          name: 'Diana',
          image: 'https://i.imgur.com/W2yVnw4.jpg',
          color: 'blue darken-4',
          deck: 'Extreme Oral',
          desc: 'Face fuck a dildo for 3 minutes'
        },
        {
          name: 'Julie Skyhigh',
          image: 'https://i.imgur.com/lO7Wuit.jpg',
          color: 'blue darken-4',
          deck: 'Extreme Oral',
          desc: 'Suck two dildos at once for 2 minutes'
        },
        {
          name: 'Selvaggia Babe',
          image: 'https://i.imgur.com/3SCn1zI.jpg',
          color: 'blue darken-4',
          deck: 'Extreme Oral',
          desc: 'Worship dildo while talking about how much you love cock for 3 minutes'
        },
        {
          name: 'Dora Venter',
          image: 'https://i.imgur.com/wlAVAYm.jpg',
          color: 'blue darken-4',
          deck: 'Extreme Oral',
          desc: 'Suck a dildo and jerk off two others'
        },
        {
          name: 'Cathy Heaven',
          image: 'https://i.imgur.com/cAvZeUT.jpg',
          color: 'blue darken-4',
          deck: 'Extreme Oral',
          desc: 'Deepthroat until you can hold it down for 20 seconds'
        },
      ],
      animOral: [
        {
          name: 'Jennifer White',
          image: 'https://i.imgur.com/4G8C8zl.gif',
          color: 'blue darken-1',
          deck: 'Anim-Oral',
          desc: "Copy the animation for 2 minutes"
        },
        {
          name: 'Emma Stoned',
          image: 'https://i.imgur.com/4l5MJJq.gif',
          color: 'blue darken-1',
          deck: 'Anim-Oral',
          desc: "Copy the animation for 1 minute"
        },
        {
          name: 'Dani Daniels',
          image: 'https://i.imgur.com/ws7jIer.gif',
          color: 'blue darken-1',
          deck: 'Anim-Oral',
          desc: "Copy the animation for 4 minutes"
        },
        {
          name: 'Unknown',
          image: 'https://i.imgur.com/g8ilJUu.gif',
          color: 'blue darken-1',
          deck: 'Anim-Oral',
          desc: "Copy the animation for 1 minute"
        },
        {
          name: 'Unknown',
          image: 'https://i.imgur.com/kYq0W7y.gif',
          color: 'blue darken-1',
          deck: 'Anim-Oral',
          desc: "Copy the animation at least 5 times"
        },
      ],
      analCards: [
        {
          name: 'Nikki Hearts',
          image: 'https://i.imgur.com/iMj5c8K.jpg',
          color: 'orange lighten-3',
          deck: 'Base Set Anal',
          desc: 'Wear a butt plug when not fucking your ass for the remainder of the game'
        },
        {
          name: 'Emma Evins',
          image: 'https://i.imgur.com/nTuAyWc.jpg',
          color: 'orange lighten-3',
          deck: 'Base Set Anal',
          desc: 'Grind on your dildo balls deep for 3 minutes'
        },
        {
          name: 'Lili Nuar',
          image: 'https://i.imgur.com/JqkAcKC.jpg',
          color: 'orange lighten-3',
          deck: 'Base Set Anal',
          desc: 'Ride your dildo slowly from top to bottom for 2 minutes'
        },
        {
          name: 'Haley Reed',
          image: 'https://i.imgur.com/NkVYJHE.jpg',
          color: 'orange lighten-3',
          deck: 'Base Set Anal',
          desc: 'Slide four fingers in your ass for 1 minute'
        },
        {
          name: 'Carmen',
          image: 'https://i.imgur.com/t3IaTqg.jpg',
          color: 'orange lighten-3',
          deck: 'Base Set Anal',
          desc: 'Slide three fingers in your ass for 1 minute'
        },
        {
          name: 'Eve Angel',
          image: 'https://i.imgur.com/ibavwBK.jpg',
          color: 'orange lighten-3',
          deck: 'Base Set Anal',
          desc: 'Slide two fingers in your ass for 1 minute'
        },
        {
          name: 'Anastasia Black',
          image: 'https://i.imgur.com/vq2qbSH.jpg',
          color: 'orange lighten-3',
          deck: 'Base Set Anal',
          desc: 'Slide one finger in your ass for 1 minute'
        },
        {
          name: 'Molly Manson',
          image: 'https://i.imgur.com/qGY0coh.jpg',
          color: 'orange lighten-3',
          deck: 'Base Set Anal',
          desc: 'Wave your ass in the air for 45 seconds'
        },
        {
          name: 'Nia Nacci',
          image: 'https://i.imgur.com/Qur8NR2.jpg',
          color: 'orange lighten-3',
          deck: 'Base Set Anal',
          desc: 'Fuck yourself on your back for 2 minutes'
        },
        {
          name: 'Olivia Devine',
          image: 'https://i.imgur.com/oyKD2r0.jpg',
          color: 'orange lighten-3',
          deck: 'Base Set Anal',
          desc: 'Fuck yourself face down, ass up for 3 minutes'
        },
      ],
      animAnal: [
        {
          name: 'Unknown',
          image: 'https://i.imgur.com/9lQLpwF.gif',
          color: 'orange darken-4',
          deck: 'Anim-Anal',
          desc: 'Copy the animation for 4 minutes'
        },
        {
          name: 'Angel Smalls',
          image: 'https://i.imgur.com/ofiqBy9.gif',
          color: 'orange darken-4',
          deck: 'Anim-Anal',
          desc: 'Copy the animation for 3 minutes'
        },
        {
          name: 'Kendra Lust',
          image: 'https://i.imgur.com/h9jpzEY.gif',
          color: 'orange darken-4',
          deck: 'Anim-Anal',
          desc: 'Copy the animation for 2 minutes'
        },
        {
          name: 'Delia DeLions',
          image: 'https://i.imgur.com/XoHaHXv.gif',
          color: 'orange darken-4',
          deck: 'Anim-Anal',
          desc: 'Copy the animation for 5 minutes'
        },
        {
          name: 'Unknown',
          image: 'https://i.imgur.com/ucmWBW9.gif',
          color: 'orange darken-4',
          deck: 'Anim-Anal',
          desc: 'Copy the animation for 1 minute'
        },
      ],
      sissyCards: [
        {
          name: 'Kylie Cole',
          image: 'https://i.imgur.com/t7RJAYa.jpg',
          color: 'pink',
          deck: 'Base Set Sissy',
          desc: 'Play the remainder of the game in white panties'
        },
        {
          name: 'Kendra Lust',
          image: 'https://i.imgur.com/W7GvPvh.jpg',
          color: 'pink',
          deck: 'Base Set Sissy',
          desc: 'Play the remainder of the game in black lingerie'
        },
        {
          name: 'Suzie Q',
          image: 'https://i.imgur.com/SZcqG9F.jpg',
          color: 'pink',
          deck: 'Base Set Sissy',
          desc: 'Play the remainder of the game in a sports bra'
        },
        {
          name: 'Aria Sky',
          image: 'https://i.imgur.com/EozMib9.jpg',
          color: 'pink',
          deck: 'Base Set Sissy',
          desc: 'Play the remainder of the game in a sundress'
        },
        {
          name: 'Lena Paul',
          image: 'https://i.imgur.com/FbRNJdr.jpg',
          color: 'pink',
          deck: 'Base Set Sissy',
          desc: 'Play the remainder of the game in high heels'
        },
        {
          name: 'Jillian Janson',
          image: 'https://i.imgur.com/7CqX0W1.jpg',
          color: 'pink',
          deck: 'Base Set Sissy',
          desc: 'Play the remainder of the game in a skirt'
        },
        {
          name: 'Brook Little',
          image: 'https://i.imgur.com/4WuV30m.jpg',
          color: 'pink',
          deck: 'Base Set Sissy',
          desc: 'Rub yourself in panties for 2 minutes'
        },
        {
          name: 'Sophia Blake',
          image: 'https://i.imgur.com/7g7FQu1.jpg',
          color: 'pink',
          deck: 'Base Set Sissy',
          desc: 'Wear eye shadow'
        },
        {
          name: 'Patty',
          image: 'https://i.imgur.com/5r9fBsi.jpg',
          color: 'pink',
          deck: 'Base Set Sissy',
          desc: 'Wear lipstick'
        },
        {
          name: 'Shyla Jennings',
          image: 'https://i.imgur.com/fluiW4P.jpg',
          color: 'pink',
          deck: 'Base Set Sissy',
          desc: 'Shave your clitty'
        },
      ],
      BDSMCards: [
        {
          name: 'Maia',
          image: 'https://i.imgur.com/K3OvPfA.jpg',
          color: 'black',
          deck: 'Base Set BDSM',
          desc: 'Play the remainder of the game with nipple clamps/clothespins'
        },
        {
          name: 'Adrianna Nicole',
          image: 'https://i.imgur.com/K1zdylh.jpg',
          color: 'black',
          deck: 'Base Set BDSM',
          desc: 'Play the remainder of the game with a gag when not sucking'
        },
        {
          name: 'Lily Jordan',
          image: 'https://i.imgur.com/jh6umfg.jpg',
          color: 'black',
          deck: 'Base Set BDSM',
          desc: 'Spank yourself 10 times'
        },
        {
          name: 'Missy Maze',
          image: 'https://i.imgur.com/eMzz7Bg.jpg',
          color: 'black',
          deck: 'Base Set BDSM',
          desc: 'Wear a chastity cage until you draw a cum card'
        },
        {
          name: 'Madeline Marlowe',
          image: 'https://i.imgur.com/TUZ2IVb.jpg',
          color: 'black',
          deck: 'Base Set BDSM',
          desc: 'Squeeze your balls for 30 seconds'
        },
        {
          name: 'Taylor Ashley',
          image: 'https://i.imgur.com/ZBbNubB.jpg',
          color: 'black',
          deck: 'Base Set BDSM',
          desc: 'Play the remainder of the game in a collar'
        },
        {
          name: 'Presley Hart',
          image: 'https://i.imgur.com/5TGS1Lk.jpg',
          color: 'black',
          deck: 'Base Set BDSM',
          desc: 'Play the remainder of the game blindfolded. Remove only to read your next card.'
        },
      ],
      threesCompany: [
        {
          name: 'Amara Romani',
          image: 'https://i.imgur.com/mA9jvkw.jpg',
          color: 'deep-purple lighten-2',
          deck: "Three's Company",
          desc: 'Suck two dildos at the same time for 2 minutes.'
        },
        {
          name: 'Chloe La Moure',
          image: 'https://i.imgur.com/HaWnxXM.jpg',
          color: 'deep-purple lighten-2',
          deck: "Three's Company",
          desc: 'Sit on a dildo while sucking another for 3 minutes.'
        },
        {
          name: 'Katrina Jade',
          image: 'https://i.imgur.com/1n51xAk.jpg',
          color: 'deep-purple lighten-2',
          deck: "Three's Company",
          desc: 'Jerk off two dildos for 1 minute.'
        },
        {
          name: 'Jewels Jade',
          image: 'https://i.imgur.com/s3NIpfh.jpg',
          color: 'deep-purple lighten-2',
          deck: "Three's Company",
          desc: 'Alternate sucking two dildos for 5 minutes.'
        },
        {
          name: 'Samantha Johnson',
          image: 'https://i.imgur.com/bEj6ifY.jpg',
          color: 'deep-purple lighten-2',
          deck: "Three's Company",
          desc: 'Fuck a dildo doggystyle while sucking another for 5 minutes.'
        },
        {
          name: 'Kira Thorn',
          image: 'https://i.imgur.com/jwryk0H.jpg',
          color: 'deep-purple lighten-2',
          deck: "Three's Company",
          desc: 'Fuck two dildos at the same time for 1 minute.'
        },
        {
          name: 'Riley Shy, Sammy Cruz',
          image: 'https://i.imgur.com/ehSEBEM.jpg',
          color: 'deep-purple lighten-2',
          deck: "Three's Company",
          desc: 'Lick a fake pussy while fucking yourself for 3 minutes.'
        },
      ],
      cumCards: [
        {
          name: 'Mandy Dee',
          image: 'https://i.imgur.com/tLuRbd4.jpg',
          color: 'green',
          deck: 'Base Set Cum',
          desc: 'Creampie! Cum in your hand, spread it on your asshole'
        },
        {
          name: 'Athena Faris',
          image: 'https://i.imgur.com/4GKpXRG.jpg',
          color: 'green',
          deck: 'Base Set Cum',
          desc: 'Facial! Cum in your hand, spread it on your face'
        },
        {
          name: 'Alex Black',
          image: 'https://i.imgur.com/L450Xvn.jpg',
          color: 'green',
          deck: 'Base Set Cum',
          desc: 'Sloppy eater! Cum in your hand, lick it up and let it drip out on your chin'
        },
        {
          name: 'Madeline Marlowe',
          image: 'https://i.imgur.com/WtmmfFY.jpg',
          color: 'green',
          deck: 'Base Set Cum',
          desc: 'Ruined Orgasm! Ruin your orgasm on your stomach'
        },
      ],
      drawnCards: []
    }),
    methods: {
      begin: function(){
        this.stage++;
        this.draw();
      },
      draw: function(){
        this.drawNumer ++;
        let cards = [];
        if(this.drawNumer > this.gameLength){
          console.log('cum in play');
          cards = this.cumCards;
        }
        let drawnCards = this.drawnCards;
        if(this.sets.includes('Oral')){
          cards.push.apply(cards, this.oralCards);
        }
        if(this.sets.includes('Extreme Oral')){
          cards.push.apply(cards, this.extremeOral);
        }
        if(this.sets.includes('Anal')){
          cards.push.apply(cards, this.analCards);
        }
        if(this.sets.includes('Anim-Anal')){
          cards.push.apply(cards, this.animAnal);
        }
        if(this.sets.includes('Anim-Oral')){
          cards.push.apply(cards, this.animOral);
        }
        if(this.sets.includes('Sissy')){
          cards.push.apply(cards, this.sissyCards);
        }
        if(this.sets.includes('BDSM')){
          cards.push.apply(cards, this.BDSMCards);
        }
        if(this.sets.includes('ThreesCompany')){
          cards.push.apply(cards, this.threesCompany);
        }
        const filteredCards = cards.filter(function(x) { 
          return drawnCards.indexOf(x) < 0;
        });
        console.log(filteredCards); 
        const randomCard = filteredCards[Math.floor(Math.random() * filteredCards.length)];
        if(randomCard.color == "green"){
          this.came = true;
        }
        this.drawnCards.push(randomCard);
        console.log(randomCard);
      }
    },
    computed: {
      cutSpot() {
        return this.$vuetify.breakpoint.smAndDown ? 2 : 4
      }
    }
  }
</script>